export const locale = {
  lang: 'es',
  multiselect_apps: {
    APPS_TITLE: 'Aplicaciones',
  }
};
